import { HStack, Box } from "@chakra-ui/react";
import CDS, { AdminMeetingTypeTag } from "design-system";
import { Meeting } from "features/Resources/Meeting/models";
import { PrefixId } from "features/Resources/Shared/models";
import { DisplayAttendeesColumn } from "features/Resources/Meeting/Components/DisplayAttendees";
import MeetingLeadCell from "features/Resources/Meeting/Components/MeetingLeadCell";
import { OtherActionsColumn } from "features/Resources/Meeting/Components/Table/MeetingSchedulingTable/OtherActionsColumn";
import { meetingTimeRange } from "helpers/time";
import { leadFromAttendees, meetingReadiness } from "features/Resources/Meeting/helpers";

interface MeetingRowProps {
  meeting: Meeting;
  onExpand: (prefixId: PrefixId) => void;
  /** Kept for call-site symmetry; the schedule only renders the by-day layout. */
  variant?: "day";
}

export default function MeetingRow({ meeting, onExpand }: MeetingRowProps) {
  const needsAttention = meetingReadiness(meeting).level === "attention";

  return (
    <HStack spacing={3} py={2.5} align="center" w="100%">
      <Box flexShrink={0} minW="120px">
        {meeting.startTime && (
          <CDS.Text14 fontWeight="medium" whiteSpace="nowrap">
            {meetingTimeRange(meeting.startTime, meeting.endTime, meeting.timezone)}
          </CDS.Text14>
        )}
      </Box>

      <Box flexShrink={0}>
        <AdminMeetingTypeTag.IconBadge meetingType={meeting.meetingType} />
      </Box>

      <HStack flex={1} minW={0} spacing={2} align="center">
        {needsAttention && <Box w="7px" h="7px" borderRadius="full" bg="red.500" flexShrink={0} />}
        <Box as="button" type="button" textAlign="left" onClick={() => onExpand(meeting.prefixId)}>
          <CDS.Text14 wordBreak="break-word" textDecorationLine={meeting.status === "skipped" ? "line-through" : "none"}>
            {meeting.name}
          </CDS.Text14>
        </Box>
      </HStack>

      <Box flexShrink={0} minW="160px">
        <MeetingLeadCell
          meetingId={meeting.id}
          meetingType={meeting.meetingType}
          status={meeting.status}
          lead={leadFromAttendees(meeting.attendees)}
        />
      </Box>
      <Box flexShrink={0}>
        <DisplayAttendeesColumn attendees={meeting.attendees} allSessionAttendees={meeting.allSessionAttendees} />
      </Box>
      <Box flexShrink={0}>
        <OtherActionsColumn meeting={meeting} />
      </Box>
    </HStack>
  );
}
